import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDyi8sC0bjstzYeSf_q7tjR93t5JEPZvCw",
  authDomain: "history-xgeyzw.firebaseapp.com",
  projectId: "history-xgeyzw",
  storageBucket: "history-xgeyzw.appspot.com",
  messagingSenderId: "230207357927",
  appId: "1:230207357927:web:9e4ed23e7361fe0b3ff342",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Firestore with default database
let db;
try {
  // Use default database (no databaseId specified)
  db = getFirestore(app);
} catch (error) {
  console.error("Failed to connect to default database:", error);
  throw new Error("Cannot connect to default Firestore database");
}

// Initialize Firebase Storage
const storage = getStorage(app);

export { db, storage };

export default app;
